import { validateEmail } from '../lib/validateEmail';
import { TDirectorInfo } from '../types';
import { isEmailValid } from './validateEmail';

export const validateInputsResultOne = (
  shareholders: TDirectorInfo[],
  currentShareholder: number,
  director?: boolean,
) => {
  const isfirstNameValid = shareholders[currentShareholder]?.firstName?.length > 0;
  const islastNameValid = shareholders[currentShareholder]?.lastName?.length > 0;
  const isBusinessEmailValid =
    validateEmail(shareholders[currentShareholder]?.email) ||
    isEmailValid(shareholders[currentShareholder]?.email);
  const isphoneValid =
    shareholders[currentShareholder]?.phone &&
    shareholders[currentShareholder]?.phone?.length === 11;
  const isNationalityValid = shareholders[currentShareholder]?.nationality?.length > 0;
  const isGenderValid = shareholders[currentShareholder]?.gender?.length > 0;
  const isIdentityNumberValid = shareholders[currentShareholder]?.identityNumber?.length === 11;
  const isBirthDateValid = shareholders[currentShareholder]?.birthDate ? true : false;
  //   const isShareValid = !director ? (shareholders[currentShareholder]?.share ? true : false) : true;
  // const sharesValid = Number(availableShares) + Number(xx) >= 0 ? true : false;

  return (
    !!isfirstNameValid &&
    !!islastNameValid &&
    !!isBusinessEmailValid &&
    !!isphoneValid &&
    !!isNationalityValid &&
    !!isGenderValid &&
    !!isIdentityNumberValid &&
    !!isBirthDateValid
    // !!isShareValid
    // sharesValid
  );
};

export const validateInputsSecond = (shareholders: TDirectorInfo[], currentShareholder: number) => {
  return (
    !!shareholders[currentShareholder]?.cityOrTown &&
    !!shareholders[currentShareholder]?.lga &&
    !!shareholders[currentShareholder]?.locatedState &&
    !!shareholders[currentShareholder]?.streetName &&
    !!shareholders[currentShareholder]?.streetNumber
  );
};

export const validateInputsThirdStage = (
  shareholders: TDirectorInfo[],
  currentShareholder: number,
) => {
  return (
    !!shareholders[currentShareholder]?.idCard?.name &&
    !!shareholders[currentShareholder]?.passport?.name &&
    !!shareholders[currentShareholder]?.proofOfAddress?.name &&
    !!shareholders[currentShareholder]?.signature?.name
  );
};

export const validateShareholder = (
  shareholders: TDirectorInfo[],
  currentShareholder: number,
  step: number,
) => {
  return (
    validateInputsResultOne(shareholders, currentShareholder, step === 5) &&
    validateInputsSecond(shareholders, currentShareholder) &&
    validateInputsThirdStage(shareholders, currentShareholder)
  );
};
